var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside-el",rawName:"v-click-outside-el",value:(_vm.hide),expression:"hide"}],class:{'card-padding':_vm.padding==true, 'card-border':_vm.border==true, 'shadow':_vm.shadow==true},attrs:{"id":_vm.cardId},on:{"click":_vm.onClickCard}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }